import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HangerPrice } from '@paragon/contract-library';

const initialState: { [guid: string]: HangerPrice } = {};

const hangerPricesSlice = createSlice({
  name: 'hangerPrices',
  initialState,
  reducers: {
    setHangerPrices: (state, action: PayloadAction<readonly HangerPrice[]>) => {
      for (const hangerPriceRecord of action.payload) {
        state[hangerPriceRecord.guid] = hangerPriceRecord;
      }
    },
  },
});

export const { setHangerPrices } = hangerPricesSlice.actions;
export const hangerPrices = hangerPricesSlice.reducer;
